import React,  { useState, useEffect } from 'react'
import axios from 'axios'
import { ProgressBarComponent } from "@syncfusion/ej2-react-progressbar";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import AES256 from 'aes-everywhere';
import * as XLSX from 'xlsx';
import $ from 'jquery';
import path from 'path-browserify';

/* tasks icons */ 
import Precheck from '@mui/icons-material/PlaylistAddCheckCircleOutlined';
import Adaptation from '@mui/icons-material/AvTimerOutlined';
import Recording from '@mui/icons-material/MicOutlined';
import Postpro from '@mui/icons-material/SpeakerOutlined';
import Qa from '@mui/icons-material/VerifiedOutlined';
import Delivery from '@mui/icons-material/MarkEmailReadOutlined';

import InterpreterModeOutlinedIcon from '@mui/icons-material/InterpreterModeOutlined';
import SettingsAccessibilityIcon from '@mui/icons-material/SettingsAccessibility';
import TuneIcon from '@mui/icons-material/Tune';

import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined';
import AI from '@mui/icons-material/RecordVoiceOverOutlined';
import { compressToEncodedURIComponent, decompressFromEncodedURIComponent } from 'lz-string';
import { saveAs } from 'file-saver';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc)
dayjs.extend(timezone);
const userTZ = dayjs.tz.guess();

// COMMET2

let pathBackend = ''
var versioning = "1.0.34"
let webSockedSource 
let timeformat12 = false;

if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"){
    console.log(`Localhost v${versioning}`)
    //console.log(`dev 1.0.34 test`)
    pathBackend = `http://localhost:80/audiomate/versions/${versioning}/`;
    webSockedSource = 'local'
    //pathBackend = `https://app.kantanaudiomate.com:8080/versions/${versioning}/`;
    //pathBackend = `https://dev.kantanaudiomate.com:8080/versions/${versioning}/`;

} else {
 
    if(window.location.hostname === "app.kantanaudiomate.com"){
      console.log(`REMOTE APP v${versioning}`)
      //console.log("Revision e")
      pathBackend = `https://app.kantanaudiomate.com:8080/versions/${versioning}/`;
      
    } else {
      console.log(`REMOTE DEV v${versioning}`)
      //pathBackend = `https://app.kantanaudiomate.com:8080/${versioning}/`;
      pathBackend = `https://dev.kantanaudiomate.com:8080/versions/${versioning}/`;
    }  
    webSockedSource = 'online'
}

let logOutData = {setUser: null, setIsLoading: null};

export const updateSetUser = (setUser, setIsLoading) => {
  logOutData.setUser = setUser;
  logOutData.setIsLoading = setIsLoading;
}

export const AM_version = () => {
  return versioning
}

export const AM_isDev = () => {
  return window.location.hostname !== "app.kantanaudiomate.com";
}

export const setTimeFormat = (newTimeformat12) => {
  timeformat12 = newTimeformat12;
}

/* take the information from the local storage for time formate*/
export const getTimeFormat = () => {
  return timeformat12;
}

var socketId = null;
export const AM_socketId = (set, id) => {
  if(set) { socketId = id };
  return socketId// ? socketId : 0;
}

export const BASE_ADR = (apiAddress) => {
    return pathBackend + '?' + apiAddress + '&hc=7B3C48E252-DC18-4B4B-97C4-34975A6F12F1'
}

export const API_ADR = (apiAddress) => {
    if(apiAddress === 'refresh=1' || apiAddress === 'logout=1') {
      return pathBackend.split('versions')[0] + 'auth/auth.php?' + apiAddress + '&hc=7B3C48E252-DC18-4B4B-97C4-34975A6F12F1';
    } else {
      return pathBackend + '?' + apiAddress + '&hc=7B3C48E252-DC18-4B4B-97C4-34975A6F12F1';
    }
}

export const API_ADRWS = (type) => {

  const websocketKey = process.env.REACT_APP_WEBSOCKET_KEY ?? '';
  if(webSockedSource === 'local') return `ws://localhost:8081/chat?&type=${type}&userprotectionkey=` + websocketKey 
  return `wss://wss.kantanaudiomate.com/chat?&type=${type}&userprotectionkey=` + websocketKey;
  //return 'ws://localhost:8081/chat?&userprotectionkey=' + websocketKey;
}

/* Badge status projects/batches/scripts */
export const ProjectStatus = (props) => {

    let title = `${props.pstatus.lineContent} "${props.pstatus.project_name}" `
    switch (parseInt(props.pstatus.status)) {
        case 0:
            return <span className="badge bg-primary" title={`${title} In Progress`}>In Progress</span>
        case 1:
            return <span className="badge bg-success" title={`${title} Closed`}>Closed</span>
        case -1:
            return <span className="badge bg-warning text-dark" title={`${title} Not in production`}>Not in production</span>
        default:
            return ""
    }
}


/* loading bar used to pass to the pages */
export const LoadingBar = (props) => {
    return (
        <ProgressBarComponent 
            id="linear"
            type="Linear"
            height="60"
            value={20}
            isIndeterminate={true}
            animation={{
                enable: true,
                duration: 2000,
                delay: 0
            }}>
        </ProgressBarComponent>
    )
}

export const ProgressionBar = (props) => {
    return (
        <ProgressBarComponent id="linear" type="Linear" height="60" value={props.value}>
        </ProgressBarComponent>
    )
}



let AudioMateModal
export const Modal = (props) => {
    const [status, setStatus] = React.useState({ hideDialog: false });
    // eslint-disable-next-line
    function handleClick() {
        setStatus({ hideDialog: true })
    }

    function dialogClose() {
        setStatus({ hideDialog: false })
    }


    return (
            <DialogComponent 
                ref={elem => AudioMateModal = elem}
                width='900px' visible = {status.hideDialog} close = {dialogClose}
                height='700px'
                showCloseIcon={true}
                >{props.content}
            </DialogComponent>

    );
}

export const ModalOpen = (props) => {
    /*AudioMateModal.content = props*/
    //AudioMateModal.refresh()
    AudioMateModal.show();
}

export const SetCssRoles = (props) => {
    let {variable, color, alpha} = props
    if(alpha === undefined){
      alpha = ''
    }
    document.documentElement.style.setProperty(`--${variable}`, color + alpha);
}

export const GetCssRoles = (props) => {
  return getComputedStyle(document.documentElement)
    .getPropertyValue(props);
  //return document.documentElement.style.getProperty(`--${props}`);
}


export const SpinnerCentered = (props) => {

    return (

        <div className="modal fade show" id="AudioMateMenu" tabIndex="-1" aria-modal="true">
            <div className="modal-content" style={{"background": "none !important","border": "none", "top": '43%', "left": '50%', 'width': '68px'}}>
                <div className="modal-body" style={{"background": "none !important"}}>
                    <div className="spinner-border text-primary" role="status" style={{margin: '2px 4px 0px 2px'}}>
                    <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

/* check if the user has the permission to see a module */
export const permissionLogic = (permissionLogic, key) =>{
    if(permissionLogic[key] === undefined){
        return false
    } 
    return true
}

/* validate password */

export const validatePassword = (password) => {
    const lengthRequirement = 12;
    const numberRegex = /\d/;
    const symbolRegex = /[!@#$%^&*()_+=~`[\]{}|:;"'<>,.?/\\-]/;
    const uppercaseRegex = /[A-Z]/;
  
    // Check the length requirement
    if(password.length < lengthRequirement) {
      return "The minimum password length is " + lengthRequirement + " characters.";
    }

    if(!numberRegex.test(password)){
        return "The password must contain at least one number.";
    }

    if(!symbolRegex.test(password)){
        return "The password must contain at least one symbol.";
    }

    if(!uppercaseRegex.test(password)){
        return "The password must contain at least one uppercase letter.";
    }

    // Check for at least one number, symbol, and uppercase letter
    /*if (!numberRegex.test(password) || !symbolRegex.test(password) || !uppercaseRegex.test(password)) {
      return false;
    }*/
  
    // All criteria are met
    return true;
  }

  /* lowercase */
export const lowercaseString = (input) => {
  if (typeof input === 'string') {
    return input.toLowerCase();
  }
  return input;
}

export const singularOrPlural = (count, singular, plural) => {
  if(count === 1){
    return singular
  } else {  
    return plural
  }
}

export const cleanString = (input) => {

  let str = String(input);
  let cleanedString = str.toLowerCase();
  cleanedString = cleanedString.replace(/[^\w\s]|_/g, "")
                               .replace(/\s+/g, "");

  return cleanedString;
}

export const sanitizeFilename = (filename) => {
  if (typeof filename !== 'string') {
      throw new Error('The file name must be a string');
  }

  /* eslint-disable-next-line no-control-regex */
  const invalidChars = /[<>:"/\\|?*\x00-\x1F]/g;

  let sanitized = filename.replace(invalidChars, '_');
  
  // removes consecutive multiple spaces
  sanitized = sanitized.replace(/\s+/g, ' ');
  
  // removes points and spaces at the beginning and in the end
  sanitized = sanitized.replace(/^[\s.]+|[\s.]+$/g, '');
  
  // manages reserved file names in Windows
  const reservedNames = /^(CON|PRN|AUX|NUL|COM[1-9]|LPT[1-9])$/i;
  if (reservedNames.test(sanitized)) {
      sanitized = '_' + sanitized;
  }
  
  // If the stream is empty after sanitization
  if (!sanitized) {
      sanitized = '_unnamed_file';
  }
  
  // limits the length of the file name (considering the most restrictive limit)
  const maxLength = 255;
  if (sanitized.length > maxLength) {
      const ext = sanitized.lastIndexOf('.');
      if (ext > -1) {
          const extension = sanitized.slice(ext);
          sanitized = sanitized.slice(0, maxLength - extension.length) + extension;
      } else {
          sanitized = sanitized.slice(0, maxLength);
      }
  }
  
  return sanitized;
}

export const sanitizeExcelTab = (tabName) => {
  if (typeof tabName !== 'string') {
      throw new Error('The name of the card must be a string');
  }
  /* eslint-disable-next-line */
  const invalidChars = /[\*\?\:\\/\[\]]/g;
  
  let sanitized = tabName.replace(invalidChars, '_');

  sanitized = sanitized.replace(/\s+/g, ' ');
  
  sanitized = sanitized.trim();
  
  if (!sanitized) {
      sanitized = '_unnamed_sheet';
  }
  
  const maxLength = 31;
  if (sanitized.length > maxLength) {
      sanitized = sanitized.slice(0, maxLength);
  }
  
  return sanitized;
}




export const manipulateString = (inputString, options = {}) => { 

    /*
    const options = {
        addPrefix: true,
        prefixString: "Greetings: ",
        addSuffix: true,
        suffixString: " - Have a nice day!",
        replaceString: "o",
        replaceWithString: "X",
        forceCase: "uppercase"
      };
    */

    let manipulatedString = inputString;
  
    if (options.addPrefix) {
      manipulatedString = options.prefixString + manipulatedString;
    }
  
    if (options.addSuffix) {
      manipulatedString += options.suffixString;
    }
  
    if (options.replaceString) {
      manipulatedString = manipulatedString.replace(new RegExp(options.replaceString, 'g'), options.replaceWithString);
    }
  
    if (options.forceCase === 'uppercase') {
      manipulatedString = manipulatedString.toUpperCase();
    } else if (options.forceCase === 'lowercase') {
      manipulatedString = manipulatedString.toLowerCase();
    }  
    return manipulatedString;
  }
  

  export const ExcelParser = (file) => {

    return new Promise((resolve, reject) => {
        const reader = new FileReader();
    
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: 'binary' });
   
          /*const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });*/
    
          resolve(workbook);
        };
    
        reader.onerror = (error) => {
          reject(error);
        };
    
        reader.readAsBinaryString(file);
      });
  };

/* handle errors */
function ErrorFallback({ error, resetErrorBoundary }) {
    return (
      <div>
        <h2>Something went wrong:</h2>
        <p>{error.message}</p>
        <button onClick={resetErrorBoundary}>Try again</button>
      </div>
    );
  }
  
  function useErrorBoundary() {
    const [error, setError] = useState(null);
  
    const resetErrorBoundary = () => {
      setError(null);
    };
  
    if (error) {
      return {
        hasError: true,
        error,
        resetErrorBoundary,
      };
    }
  
    return {
      hasError: false,
      error: null,
      resetErrorBoundary,
    };
  }
  
  export default function ErrorBoundary({ children }) {
    const { hasError, error, resetErrorBoundary } = useErrorBoundary();
  
    if (hasError) {
      return <ErrorFallback error={error} resetErrorBoundary={resetErrorBoundary} />;
    }
  
    return children;
  }

  export const saveAsAM = async (blobData, fileName, options) => {
      try {
          const handle = await window.showSaveFilePicker(options);
          const writable = await handle.createWritable();
          await writable.write(blobData);
          await writable.close();
          return { success: true };
      } catch (err) {
          if (err.name === 'AbortError') {
              return { success: false, aborted: true };
          } else {
              saveAs(blobData, fileName);
              return { success: true, aborted: false };
          }
      }
  };

export const copyStyles = (sourceDoc, targetDoc) => {

  Array.from(sourceDoc.styleSheets).forEach(styleSheet => {
      if (styleSheet.cssRules) { // for <style> elements
          const newStyleEl = sourceDoc.createElement('style');

          Array.from(styleSheet.cssRules).forEach(cssRule => {
              // write the text of each rule into the body of the style element
              newStyleEl.appendChild(sourceDoc.createTextNode(cssRule.cssText));
          });

          targetDoc.head.appendChild(newStyleEl);
      } else if (styleSheet.href) { // for <link> elements loading CSS from a URL
          const newLinkEl = sourceDoc.createElement('link');

          newLinkEl.rel = 'stylesheet';
          newLinkEl.href = styleSheet.href;
          targetDoc.head.appendChild(newLinkEl);
      }
  });
}


//Returns an array of allowed file formats for AudioMate.
export const allowedFileFormats = () => {
  return [".wav", ".mp3", ".ogg", ".flac", ".avi", ".aac", "m4a", ".mov", ".mp4", ".wma", ".webm", ".aif", ".aiff"];
}

export const unsupportedFormats = ["aiff", "aif"];



/* generate random string */
export const generateRandomString = (length) => {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  var charactersLength = characters.length;

  for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
}


// use as default to have local times
export const userLocalTime = (time, format = 'YYYY-MM-DD HH:mm') => {
    return dayjs.utc(time).tz(userTZ).format(format)
}

/* format date 12/24 hours */
export const AM_UserDateTime = (dateString, noTime = false) => {

  try{

  var is12HourFormat = getTimeFormat()

      // Array of abbreviated month names
    const abbreviatedMonths = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    const date = new Date(dateString);
    let day = date.getDate();
    let month = date.getMonth();
    let year = date.getFullYear();
    
    if(noTime) return `${day}-${abbreviatedMonths[month]}-${year}`;

    let hours = date.getHours();
    let minutes = date.getMinutes();
  
    let hoursFormatted
    let minutesFormatted = minutes.toString().padStart(2, '0'); // Aggiungi uno zero se necessario

  
    if (is12HourFormat) {
      const amOrPm = hours >= 12 ? 'PM' : 'AM';
      hoursFormatted = hours % 12 || 12; // Converti in formato 12 ore
      hoursFormatted = hoursFormatted.toString().padStart(1, '0'); // Aggiungi uno zero se necessario
      return `${day}-${abbreviatedMonths[month]}-${year} ${hoursFormatted}:${minutesFormatted} ${amOrPm}`;
    } else {
      hoursFormatted = hours.toString().padStart(2, '0');;
      return `${day}-${abbreviatedMonths[month]}-${year} ${hoursFormatted}:${minutesFormatted}`;
    }
  } catch(e) {
    return ""
  }
}

// Variabile globale per memorizzare il timezone dell'utente
let userTimezone = null;

// Funzione per ottenere il timezone con caching
const getUserTimezone = () => {
    if (!userTimezone) {
        userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    return userTimezone;
}

export const AM_UserDateTimeTZ = (dateString) => {
  try {
    const is12HourFormat = getTimeFormat(); // Funzione che determina il formato orario
    const timezone = userTimezone ?? getUserTimezone(); // Recupera il timezone (cached)

    // Array di mesi abbreviati
    const abbreviatedMonths = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    // Crea un oggetto Date e convertilo nel timezone dell'utente
    const utcDate = new Date(dateString); // Data in UTC
    const localDate = new Date(utcDate.toLocaleString('en-US', { timeZone: timezone }));

    // Ottenere i valori di giorno, mese, anno, ore e minuti
    let day = localDate.getDate();
    let month = localDate.getMonth();
    let year = localDate.getFullYear();

    let hours = localDate.getHours();
    let minutes = localDate.getMinutes();

    let hoursFormatted;
    const minutesFormatted = minutes.toString().padStart(2, '0'); // Aggiungi uno zero se necessario

    if (is12HourFormat) {
      const amOrPm = hours >= 12 ? 'PM' : 'AM';
      hoursFormatted = hours % 12 || 12; // Converti in formato 12 ore
      return `${day}-${abbreviatedMonths[month]}-${year} ${hoursFormatted}:${minutesFormatted} ${amOrPm}`;
    } else {
      hoursFormatted = hours.toString().padStart(2, '0'); // Formato 24 ore
      return `${day}-${abbreviatedMonths[month]}-${year} ${hoursFormatted}:${minutesFormatted}`;
    }
  } catch (e) {
    console.error('Errore nella formattazione della data:', e);
    return '';
  }
};

export const formatHours = (seconds) => {
  const totalSeconds = Math.round(seconds);
  const hour = Math.floor(totalSeconds / 3600);
  const min = Math.floor((totalSeconds % 3600) / 60);
  const sec = totalSeconds % 60;
  
  return `${hour.toString().padStart(2, '0')}:${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
}

/* script control height */
export const scriptControlHeight = (heightscreen) => {

  if(heightscreen === 'none'){
    heightscreen = window.innerHeight;
  }

  //check the top position of #scriptTable

  let basicscriptHeight = heightscreen 

  const element = $('#playerContainer');

  if(element !== undefined){

      if(element.is('.fullpage')){
          basicscriptHeight = basicscriptHeight - 50;
      }
  }

  const table = $('#scriptTable');
  if(table.length === 1){
    const position = table.offset();

    //if(position.top > 60){
      basicscriptHeight = basicscriptHeight - position.top - 50;
    //}

  }

  const fullscreenScript = $('#scriptcontainer.scriptfullscreen').length;
  if(fullscreenScript > 0){
      basicscriptHeight = basicscriptHeight + 30;
      if(element !== undefined){
          if(element.is('.fullpage')){
              basicscriptHeight = basicscriptHeight - 30;
          }
      }
  }

  document.documentElement.style.setProperty(`--div-height-basicscript`, basicscriptHeight + 'px');
  document.documentElement.style.setProperty(`--div-height-pronunciationspanel`, basicscriptHeight +  'px');
  document.documentElement.style.setProperty(`--div-height-scriptpronunciations`, (basicscriptHeight - 143) +  'px');

}

export const mediaControlHeight = () => {

  const viewport = window.innerHeight;
  const mediaCommandBar = $('#mediaCommandBar');
  if(mediaCommandBar.length === 1){
    let mediaCommandBarBottom = mediaCommandBar.offset().top + mediaCommandBar.outerHeight(true);

    const playerAtBottom = $('#playerContainer')
    if(playerAtBottom.length === 1 && playerAtBottom.is('.fullpage')){
      mediaCommandBarBottom = mediaCommandBarBottom - playerAtBottom.outerHeight(true) + 150;
    }
    $('#mediaTable').height(viewport - mediaCommandBarBottom - 50);
  }
}



// if the filename is a cinematic
export const isCinematic = (pathstring) => {
  const parsePath = path.parse(pathstring.toLowerCase()).ext
  const videoExtensions = ['.mp4', '.mov', '.avi', '.mkv'];
  return videoExtensions.includes(parsePath);
}

/* remove dupllicates in key*/ 
export const removeDuplicates = (array, key) => {
  return array.reduce((acc, current) => {
    if (!acc.some(item => item[key] === current[key])) {
      acc.push(current);
    }
    return acc;
  }, []);
};

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    console.log('Text copied to clipboard successfully!');
  } catch (err) {
    console.error('Error copying to clipboard:', err);
  }
}

export const copyHTMLToClipboard = async (html) => {
    try {
        const type = "text/html";
        const blob = new Blob([html], { type });
        const data = [new ClipboardItem({ [type]: blob })];
        await navigator.clipboard.write(data);
    } catch (err) {
        console.error('Error copying HTML to clipboard:', err);
    }
}

/* TASKS ICONS */
export const IconTask = (props) => {
  const iconInfo = props.icon.split('-')
  const type = iconInfo[0]
  let size
  if(iconInfo.length === 2){
    size = iconInfo[1]
  } else {
    size = 20
  }

  const style = { width: size, height: 'auto' }

  if(type === 'precheck'){
    return <Precheck style={style} />
  } else if(type === 'adaptation'){
    return <Adaptation style={style} />
  } else if(type === 'recording'){
    return <Recording style={style} />
  } else if(type === 'postpro'){
    return <Postpro style={style} />
  } else if(type === 'qa'){
    return <Qa style={style} />
  } else if(type === 'delivery'){
    return <Delivery style={style} />
  }
}

export const IconUserRole = (props) => {
  const iconInfo = props.icon.split('-')
  const type = iconInfo[0]
  let size
  if(iconInfo.length === 2){
    size = iconInfo[1]
  } else {
    size = 20
  }


  
  const style = {...props.style, fontSize: size + 'px', width: size, height: 'auto' }

  if(type === 'director'){
    return <InterpreterModeOutlinedIcon style={style} />
  } else if(type === 'di___rector'){
    return <SettingsAccessibilityIcon style={style} />
  } else if(type === 'recording_engineer'){
    return <TuneIcon style={style} />
  } else if(type === 'recording_room'){
    return <i className="bi bi-box"></i>
  } else if(type === "humans"){
    return <PermIdentityOutlinedIcon style={style} sx={{color: props?.color ?? null}} />
  } else if(type === "ai"){
    return <AI style={style} sx={{color: props?.color ?? null}} title={props?.title ?? ''} />
  }
}
  

export const TextWithLinks = ({ text }) =>  {
  // Funzione per convertire il testo in elementi JSX
    const convertTextToLinks = (text) => {

      const linkRegex = /\[LINK\](.*?)\[\/LINK\]/g;
      let parts = [];
      let lastIndex = 0;

      // Find all matches for links in the text
      text.replace(linkRegex, (match, url, index) => {
        // Add text before the link
        parts.push(text.substring(lastIndex, index));

        // Add the link
        parts.push(<a href={url} title={url} target="_blank" rel="noreferrer" key={index}>[Link]</a>);

        // Updates the index of the last processed character
        lastIndex = index + match.length;
      });

      // Add any remaining text after the last link
      parts.push(text.substring(lastIndex));

    return parts;
  }

  if(text){
    return convertTextToLinks(text)
  }
}

/* css change text color based on background color */
export const getTextColorBasedOnBgColor = (hexColor) => {
  // Convert hex color to RGB
  const r = parseInt(hexColor.substr(1, 2), 16);
  const g = parseInt(hexColor.substr(3, 2), 16);
  const b = parseInt(hexColor.substr(5, 2), 16);

  // Calculate luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // If the luminance is less than 0.5, the text should be white, otherwise black
  return luminance < 0.5 ? '#FFFFFF' : '#000000';
}

export const getBrowserName = () => {
  const userAgent = navigator.userAgent;

  // List of popular browsers and key strings in their User Agents
  if (userAgent.includes("Firefox")) {
    return "Firefox";
  } else if (userAgent.includes("Edg")) {
    return "Edge";
  } else if (userAgent.includes("OPR") || userAgent.includes("Opera")) {
    return "Opera";
  } else if (userAgent.includes("Chrome")) {
    return "Chrome";
  } else if (userAgent.includes("Safari")) {
    // Safari should be checked after Chrome because they both include the string "Safari"
    return "Safari";
  } else {
    return "Unknown Browser";
  }
}


export const AMModal = ({ children, ...props }) => {


  const [expanded, setExpanded] = useState(true)


  return <div className="modal show" id="AudioMateMenu" tabIndex="-1" aria-modal="true">
      <div className={`modal-dialog ${props.size ? `modal-${props.size} ` : '' }${props.alignTop ? '' : 'modal-dialog-centered '}modal-dialog-scrollable`} style={{
          opacity: props.opacity ?? null,
          width: props.width ?? null,
          maxWidth: props.width ?? null,
          ...(props.alignTop ? {marginTop: '-30px', marginBottom: '10px'} : {})
      }}
      >
          <div className="modal-content" id="AudioMateWindowMenu" style={{...(props.removeTop ? {top: '0px'} : {}), ...(props.height ? {height: expanded? props.height : '37px', display: 'flex', flexDirection: 'column'} : {height: expanded ? null : '37px'})}}>
              <div className="modal-header" style={{padding: '0px 2px 0px 13px'}}>
                  <h5 className="modal-title">{props.header_title ?? '[No title]'}</h5>
                  <div style={{marginLeft: 'auto', display: 'flex', alignItems: 'center'}}>
                      {props?.headerReduction === true && <button title={'Minimize'} type="button" className="btn p-0" onClick={() => setExpanded(prev => !prev)} ><i className={`bi bi-arrows-${expanded ? 'collapse' : 'expand'}`} style={{position: 'relative', top: '1px', fontSize: '15px'}}></i>
                      </button>} 
                      {props.closeHandler && <button title={props.close_title ?? 'Close'} disabled={!expanded} type="button" className="btn p-0" data-bs-dismiss="modal" aria-label="Close" onClick={!expanded ? null : props.closeHandler} style={{margin: '0px 4px 0px 5px'}}><i style={{position: 'relative', top: '3px', fontSize: '25px'}} className="bx bx-x"></i></button>}
                  </div>
              </div>
              {props.popupContent && <div style={{position: 'absolute', background: '#0000004d', width: '100%', height: '100%', zIndex: 9999}}>
                  <div className="modal-dialog modal-dialog-centered" style={{width: props.popupContentWidth ?? '80%', }}>
                      <div className="modal-content">
                          {props.popupShowheader && <div className="modal-header" style={{padding: '3px 8px 0px 11px'}}>
                              <h6 className="modal-title">{props.popupTitle ?? 'Warning title'}</h6>
                              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={props.popupClose}></button>
                          </div>}
                          <div className="modal-body" style={{padding: '0px 8px 8px 11px'}}>
                            {props.popupContent}
                          </div>
                          {props.popupButton && <div className="modal-footer p-1" style={{display: 'flex', justifyContent: 'center'}}>
                              {props.popupButton}
                          </div>}
                      </div>
                  </div>  
              </div>}
              <div className={`modal-body${props.contentClass ? ' ' + props.contentClass : ''}`} style={{overflowY: props.overflowY ?? 'unset', fontSize: props.bodyFontSize ?? null, height: props.contentHeight ?? null, ...(props.height ? {flex: 1, minHeight: 0} : {})}}>
                  {children}   
              </div>
              {props?.nofooter !== true && <><hr style={{margin: 0}}/>
                  <div className="text-center pt-2 pb-2">
                      {props.buttons} 
                  </div></>
              }
          </div> 
      </div>
  </div>
}

export const AMSearch = (props) => {

  const [inputValue, setInputValue] = useState('')

  useEffect(() => {
      let timeout;
      const handleSearch = () => {
          // Here you can enter your search logic
          props.onSearch(inputValue.trim())
      };
      const clearSearch = () => {
        setInputValue("") 
      };
      if (props.clearSearch) props.clearSearch.current = clearSearch

      timeout = setTimeout(() => {
          handleSearch();
      }, 500);

      return () => {
          clearTimeout(timeout);
      };
  // eslint-disable-next-line
  }, [inputValue]);

  const searchValue = (e) => {
      setInputValue(e.target.value)
  }

  return <input ref={props.reference} type="search" className="form-control searchtext" placeholder={props.placeholder ?? 'Search...'} value={inputValue}

      style={inputValue === '' ? {width: props.width ?? '165px', float: 'right', height: '30px'}
                              : {width: '165px', float: 'right', height: '30px', background: '#ff00003b'}} onChange={searchValue} spellCheck={false} />
}

axios.interceptors.request.use(async (config) => {
  const token = await getClerkToken?.();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const match = window.location.pathname.match(/^\/u\/(\d+)/);
  if (match) config.headers["X-User-Id"] = match[1];
  config.withCredentials = true;

  return config;
}, error => {
  return Promise.reject(error);
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(axios({ ...prom.config }));
    }
  });
  failedQueue = [];
};

axios.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      if (!isRefreshing) {
        isRefreshing = true;
      
        try {  
            
          const url = API_ADR('refresh=1');
          const valid = await axios.get(url);
          if(!valid?.data?.access) throw new Error('Invalid token');  
          //setUserDataStorage(valid?.data?.access);
             
          const retryOriginalRequest = axios(originalRequest);
          processQueue();
          return retryOriginalRequest;
             
        } catch (refreshError) {
          processQueue(refreshError);
          logOut();
          
          return Promise.reject(refreshError);
        } finally {
          isRefreshing = false;
        }
      }
      return new Promise((resolve, reject) => {
        failedQueue.push({
          resolve,
          reject,
          config: originalRequest
        });
      });
    }
    return Promise.reject(error);
  }
);

let setUserData = null;
export const setUserDataFn = (fn) => {
  setUserData = fn;
};

export const getUserDataFn = () => {
  return setUserData;
};

let getClerkToken = null;
export const setGetClerkToken = (fn) => {
    getClerkToken = fn;
};

let clerkSignOut = null;
export const setSignOut = (fn) => {
  clerkSignOut = fn;
}

export const logOut = async () => {
  clerkSignOut?.()
    //dBConn.get('logout=1'); 
    //document.documentElement.style.setProperty(`--zendesstatus`, '0');
    //logOutData.setUser?.(false);
    //logOutData.setIsLoading?.(false);
}

export const dBConn = async (address, data, method = 'post') => {

  const link = API_ADR(address);
  
  try {
      const response = await axios({
          method, // Use the dynamic method (get, post, etc.)
          url: link,
          data: method === 'post' ? data : null, // Only include data for POST
          headers: {
            'Content-Type': 'text/plain',
          },
          withCredentials: true,
      });
      //console.log(response.data);
      return response.data;
  } catch (error) {
      return null;
  }
};

// Attach GET and POST methods to the dBConn object
dBConn.get = (address) => dBConn(address, null, 'get');
dBConn.post = (address, data) => dBConn(address, data, 'post');

let statsTimeout = null;

export const AMStats = (module, description, values = 1, details = null) => {
  if (statsTimeout) return; 
      // examples 
    //AMStats('media', 'access'); // just access
    //AMStats('media', 'download', 3568); // just counters

  statsTimeout = setTimeout(() => {
    dBConn.post("am-stats", { module, description, values, details })
      .then((response) => {
        
      });
    statsTimeout = null; 
  }, 500);
};

//export const OpenPortalWindow = ({open, children, ref}) => {
//  const openPortal = useRef(ref);
//  
//}



export const downloadViaBlob = async (url, filename) => {
  // 1) I download the file as a blob
  const response = await fetch(url, {
    method: 'GET',
    // if you need special headers, add them here
  });
  if (!response.ok) {
    throw new Error(`Download fallito: ${response.status} ${response.statusText}`);
  }
  const blob = await response.blob();

  // 2) Create an object URL
  const blobUrl = window.URL.createObjectURL(blob);

  // 3) Create and use the anchor with download
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();

  // 4) Clean up
  window.URL.revokeObjectURL(blobUrl);
  document.body.removeChild(a);
}


/* used for default silences */
export const silenceLimitsArray = () => {
    return {
      head: {
        min: 0, max: 100
      }, tail: {
        min: 0, max: 100
      }
    }
}

export const encodeFilters = (filters) => compressToEncodedURIComponent(JSON.stringify(filters));
export const decodeFilters = (str) => JSON.parse(decompressFromEncodedURIComponent(str));